module.exports = __webpack_public_path__ + "0f56aa6b82e8710b662d73a22010e7c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/X.png
// module id = 608
// module chunks = 0